import { Helmet } from "react-helmet";
import PageHeader from "../components/pageHeader";
import Presentation from "../components/presentation";

const PresentationPage = () => {
    return (
        <>
            <Helmet>
                <title>Презентация | G-Factory</title>
                <meta name="description" content="Презентация G-Factory: просмотр и скачивание в формате PDF." />
            </Helmet>
            <PageHeader title="Презентация" breadcrumbs={[{ text: "Презентация" }]} />
            <Presentation />
        </>
    );
};

export default PresentationPage;
